import { render } from "./Galery.vue?vue&type=template&id=71664980&scoped=true"
import script from "./Galery.vue?vue&type=script&lang=ts"
export * from "./Galery.vue?vue&type=script&lang=ts"

import "./Galery.vue?vue&type=style&index=0&id=71664980&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71664980"

export default script